var _ellipse, _path, _path2, _path3, _path4, _circle, _path5, _ellipse2, _ellipse3, _path6, _path7, _path8, _rect, _path9, _path10, _path11, _path12, _rect2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse4, _ellipse5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmileDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "illustration styles_illustrationTablet__1DWOa",
    width: 406,
    height: 306,
    "data-name": "#280_smiley_face_flatline",
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.86,
    cy: 253.76,
    rx: 86.08,
    ry: 7.61,
    fill: "#2d3748"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.84,218.6a4,4,0,0,1-3.19-1.57c-8.62-11.3-30.88-39.65-33.25-42.15a4,4,0,0,1,4.89-6.31c2.37,1.62,34.41,43.19,34.72,43.61a4,4,0,0,1-3.17,6.42Zm-36.39-43.68a2.66,2.66,0,0,0,.32.25A3.92,3.92,0,0,1,212.45,174.92Z",
    fill: "#e2e8f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m255.51 111.42a78.81 78.81 0 0 1 -16.21 -1.7 4 4 0 1 1 1.8 -7.8 72.78 72.78 0 0 0 14.87 1.5c7 0 16.38-1.29 21.64-7s5.8-15.46 1.51-28.85a4 4 0 1 1 7.62 -2.44c5.23 16.33 4.14 28.69-3.25 36.72-7.09 7.69-18.49 9.57-27.98 9.57z",
    fill: "#e2e8f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.71,166.48a4,4,0,0,1-2.78-1.13c-4.12-4-24.66-24.42-24.66-36.18,0-12.82,29.4-20.85,38.42-23a4,4,0,1,1,1.86,7.78c-16.89,4-32.28,11.3-32.28,15.22,0,6.18,13,21.52,22.21,30.43a4,4,0,0,1-2.77,6.88Z",
    fill: "#e2e8f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.06,224.25a4,4,0,0,1-3.85-2.93c-6.21-22.33,4.08-44.55,7.47-51.85.27-.59.57-1.23.71-1.56a4,4,0,0,1,7.88.5c.12,1.28-.24,2.07-1.33,4.42-3.08,6.64-12.45,26.85-7,46.35a4,4,0,0,1-3.86,5.07Zm4.25-55.08h0Zm0,0Z",
    fill: "#e2e8f0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 191.22,
    cy: 122.54,
    r: 65.45,
    fill: "#e53838"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M191.22,57.1a65.45,65.45,0,1,1-65.45,65.44A65.44,65.44,0,0,1,191.22,57.1m0-1a66.48,66.48,0,1,0,66.48,66.48,66.56,66.56,0,0,0-66.48-66.48Z",
    fill: "#e2e8f0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.68,
    cy: 105.82,
    rx: 5.2,
    ry: 12.34,
    fill: "#e2e8f0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.77,
    cy: 105.82,
    rx: 5.2,
    ry: 12.34,
    fill: "#e2e8f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m191.22 165.38c-20.93 0-38-13.07-38-29.12a1.5 1.5 0 0 1 3 0c0 14.4 15.69 26.12 35 26.12s35-11.72 35-26.12a1.5 1.5 0 0 1 3 0c-0.04 16.05-17.07 29.12-38 29.12z",
    fill: "#e2e8f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m270.74 73.27s-17.23-18.1-18.38-22.63 3.64-5.16 6.79-2.64 8.85 9.4 8.85 9.4-6.67-26.4-5.09-29.55 26.21-5.09 29.22 6.3a180 180 0 0 1 5 34.57z",
    fill: "#1a202c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.74,73.78a.47.47,0,0,1-.37-.16c-.71-.74-17.34-18.25-18.51-22.86-.64-2.54.49-3.7,1.22-4.17,1.67-1.06,4.36-.62,6.4,1a80.16,80.16,0,0,1,7.5,7.78c-1.62-6.62-5.93-25-4.52-27.79,1-2,8.51-3.22,15.42-2.51,4.76.5,13,2.31,14.76,8.91,4.37,16.52,5,34.5,5,34.68a.52.52,0,0,1-.42.53l-26.42,4.55ZM255.22,47.06a3,3,0,0,0-1.58.4c-.87.56-1.14,1.61-.78,3,.87,3.44,12.08,15.91,18.06,22.2l25.7-4.42c-.13-2.88-1-19.05-5-34-1.58-6-9.37-7.67-13.86-8.14-7-.73-13.75.65-14.4,1.94-1.1,2.19,2.47,18.66,5.13,29.19a.52.52,0,0,1-.27.59.54.54,0,0,1-.63-.13c-.06-.07-5.73-6.82-8.78-9.3A6,6,0,0,0,255.22,47.06Z",
    fill: "#e2e8f0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(-8.26 49.19) rotate(-9.77)",
    x: 266.2,
    y: 68.66,
    width: 34.67,
    height: 8.51,
    rx: 3.99,
    fill: "#1a202c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.42,80A4.51,4.51,0,0,1,266,76.21l-.09-.53a4.5,4.5,0,0,1,3.67-5.2L295.88,66a4.49,4.49,0,0,1,5.2,3.67l.1.53a4.5,4.5,0,0,1-3.68,5.2l-26.31,4.53A5.12,5.12,0,0,1,270.42,80Zm26.23-13a3.92,3.92,0,0,0-.59,0L269.75,71.5a3.45,3.45,0,0,0-2.83,4L267,76a3.46,3.46,0,0,0,4,2.83l26.32-4.53h0a3.48,3.48,0,0,0,2.83-4l-.09-.53A3.48,3.48,0,0,0,296.65,66.91Z",
    fill: "#e2e8f0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M284.35,60.49a.51.51,0,0,1-.39-.19c-2.61-3-5.45-4.71-8.42-4.91a10.8,10.8,0,0,0-7.19,2.39.52.52,0,1,1-.69-.77,11.62,11.62,0,0,1,7.93-2.65c3.27.22,6.35,2,9.15,5.27a.51.51,0,0,1-.06.73A.46.46,0,0,1,284.35,60.49Z",
    fill: "#e2e8f0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.35,151.65s9.41,11.71,11.94,17-3.9,18.6-8.27,21.82-22.74,4.13-23,0,7.78-4.58,7.78-4.58-7.32-2.77-4.79-11.73L110,161.77Z",
    fill: "#1a202c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.08,193.75c-3.19,0-6.09-.36-7.78-1.16-1.12-.53-1.72-1.23-1.76-2.09-.08-1.36.58-3.22,4.16-4.36a18.31,18.31,0,0,1,2.47-.58c-2.08-1.4-5.46-4.8-3.68-11.37l-5-12.22a.5.5,0,0,1,.25-.66l21.37-10.13a.52.52,0,0,1,.62.14c.38.48,9.48,11.83,12,17.1s-3.75,19-8.43,22.46C132.9,192.67,126.57,193.75,121.08,193.75ZM110.65,162,115.51,174a.5.5,0,0,1,0,.34c-2.37,8.41,4.2,11,4.48,11.11a.53.53,0,0,1,.33.56.53.53,0,0,1-.48.44c-.08,0-7.49.46-7.29,4,0,.45.42.86,1.17,1.22,4.29,2,17.42,1,21-1.61,4.34-3.2,10.47-16.24,8.11-21.18-2.25-4.69-10.11-14.67-11.63-16.58Z",
    fill: "#e2e8f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "translate(-64 84.89) rotate(-31.16)",
    x: 102.91,
    y: 152.97,
    width: 34.67,
    height: 8.51,
    rx: 3.99,
    fill: "#1a202c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109,168.87a5,5,0,0,1-1.08-.13,4.49,4.49,0,0,1-2.78-2.05l-.28-.46a4.52,4.52,0,0,1,1.53-6.18l22.85-13.81a4.5,4.5,0,0,1,6.18,1.52l.28.46a4.49,4.49,0,0,1-1.53,6.18l-22.85,13.82A4.47,4.47,0,0,1,109,168.87Zm22.56-22.25a3.48,3.48,0,0,0-1.79.5l-22.85,13.82a3.47,3.47,0,0,0-1.17,4.76l.27.46a3.48,3.48,0,0,0,4.77,1.17l22.85-13.81h0a3.48,3.48,0,0,0,1.17-4.77l-.27-.45a3.46,3.46,0,0,0-3-1.68Z",
    fill: "#e2e8f0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M175.21,217s-28.22-5.51-28.45-2.75.92,25.27.92,25.27-27,14.5-22.85,16.34,50.38-6.7,50.38-6.7Z",
    fill: "#1a202c"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M127.17,256.65a7.38,7.38,0,0,1-2.55-.29,1.11,1.11,0,0,1-.73-1c0-.63-.09-2.31,11.84-9.56,5.05-3.07,10.16-5.87,11.41-6.55-.14-2.89-1.11-22.41-.9-25a1,1,0,0,1,.41-.69c2.61-2,24.33,2.14,28.66,3a.51.51,0,0,1,.41.5v32.16a.51.51,0,0,1-.42.51C171.06,250.48,137.33,256.65,127.17,256.65ZM149.59,214c-1.29,0-2.12.12-2.34.39-.2,2.63.93,24.91.94,25.14a.5.5,0,0,1-.27.48c-11.36,6.11-23.07,13.51-23,15.32,0,0,0,.06.12.1,3.24,1.44,36.53-4.24,49.65-6.66v-31.3C164.72,215.52,154.2,214,149.59,214Z",
    fill: "#e2e8f0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m254.33 195.33s-18.21 4.26-22.4 20.67l24 33.08 32.55-45.43-24 8.22z",
    fill: "#1a202c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M255.91,249.59a.5.5,0,0,1-.42-.21l-24-33.08a.5.5,0,0,1-.08-.43c4.21-16.52,22.6-21,22.78-21.05a.52.52,0,0,1,.56.24l9.87,16.19,23.65-8.09a.52.52,0,0,1,.58.18.51.51,0,0,1,0,.61l-32.55,45.43a.54.54,0,0,1-.42.21ZM232.49,215.9l23.41,32.3,31.2-43.54-22.52,7.7a.53.53,0,0,1-.6-.22l-9.89-16.22C251.55,196.63,236.33,201.43,232.49,215.9Z",
    fill: "#e2e8f0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m257.24 250.31c-8.89-7 0.87-18.05 10.2-30.44 6.7-8.91 19.12-19.79 25.13-15.08 6.91 5.41-24.78 53.79-35.33 45.52z",
    fill: "#d1d3d4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M260.08,251.78a5,5,0,0,1-3.16-1.07h0c-8.53-6.69-.63-17.06,7.74-28,.78-1,1.58-2.06,2.36-3.11,5.47-7.27,14.36-15.48,21-16.35a6.39,6.39,0,0,1,4.92,1.17c1,.8,1.37,2.33,1.06,4.55-1.49,10.45-18.9,37.41-30.69,42.15A8.65,8.65,0,0,1,260.08,251.78Zm-2.52-1.88c1.32,1,3.11,1.11,5.32.22,10.56-4.24,28.49-30.37,30.05-41.33.18-1.26.2-2.9-.68-3.59a5.37,5.37,0,0,0-4.15-1c-6,.79-14.74,8.62-20.25,16l-2.37,3.12c-8.4,11-15.65,20.54-7.92,26.6Z",
    fill: "#e2e8f0"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.8,
    cy: 119.33,
    rx: 7.96,
    ry: 5.06,
    fill: "#1a202c"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.65,
    cy: 119.33,
    rx: 7.96,
    ry: 5.06,
    fill: "#1a202c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileDark);
export default __webpack_public_path__ + "static/media/smile-dark.3e90eac7d586f00a79a33f8ab2b4c93e.svg";
export { ForwardRef as ReactComponent };